import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { selectCurrentToken } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import paths from '@src/routes/routes';
import { getSessionToken, getToken, isTokenValid } from '@src/utils/auth';

type GuestGuardProps = PropsWithChildren;

const GuestGuard: FC<GuestGuardProps> = (props) => {
  const { children } = props;

  const token =
    useAppSelector(selectCurrentToken) ?? getToken() ?? getSessionToken();
  const navigate = useNavigate();
  const isValid = isTokenValid(token);

  useEffect(() => {
    if (token && isValid) {
      navigate(paths.dashboard.root, { replace: true });
    }
  }, [navigate, token, isValid]);

  if (token && isValid) return null;

  return children;
};

export default GuestGuard;
